export default Object.freeze({
    TEAM: 'Team',
    SITE: 'Site',
    PERSONAL: 'Personal',
});
